export function MoonIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_2327_7471)">
        <path
          d="M6.75687 1.75684C6.44255 2.79688 6.41625 3.90271 6.68079 4.95651C6.94533 6.01032 7.4908 6.97262 8.25907 7.74089C9.02734 8.50916 9.98964 9.05463 11.0434 9.31917C12.0973 9.58371 13.2031 9.55741 14.2431 9.24309C13.9416 10.2345 13.3885 11.1308 12.6376 11.8449C11.8868 12.559 10.9638 13.0665 9.95852 13.3179C8.95327 13.5693 7.90005 13.5561 6.90142 13.2796C5.9028 13.003 4.99282 12.4726 4.26011 11.7399C3.5274 11.0071 2.99693 10.0972 2.72038 9.09854C2.44383 8.09991 2.43062 7.04669 2.68203 6.04144C2.93344 5.0362 3.44091 4.11319 4.15501 3.36233C4.86911 2.61147 5.7655 2.05835 6.75687 1.75684Z"
          fill="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2327_7471">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
